import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB, Satispay, RESPONSE, AppInfo, EitUrl } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon, ET_TipoConsegna, ET_TipoOraConsegna } from '../../shared/services/config-app';
import { ApiService } from "../../shared/services/api.service";
import { EdenredService } from "../../shared/services/edenred-service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CouponModalComponent } from '../../shared/components/modal/coupon-modal/coupon-modal.component';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-checkpay',
  templateUrl: './checkpay.component.html',
  styleUrls: ['./checkpay.component.scss']
})
export class CheckpayComponent implements OnInit {

  public location: any = null;
  public restaurant: any = null;
  public payments: any = null;
  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  public tipoConsegna: any = ET_TipoConsegna;
  public tipoOra: any = ET_TipoOraConsegna;
  hideCash: boolean = false;
  private authUrlEdenred: any = "";


  constructor(private route: ActivatedRoute, private router: Router, private modalService: NgbModal, private authService: AuthService,
    private cartService: CartService, private api: ApiService, private eService: EdenredService) {
    this.hideCash = false;
    this.cartData = new EitCart();
    this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));

    this.authUrlEdenred = "";

    this.eService.eLogin(this.cartData.order_id).then(
      res => {
        this.authUrlEdenred = res;
      },
      err => {
        console.log(err);
      }
    );

    if (this.restaurant) {
      this.payments = this.restaurant.payments;
    }

    this.cartService.cartObs.subscribe(x => {

      this.cartData = x;

      if (this.cartData != undefined && this.cartData != null) {
        let isTakeaway = this.cartData.order.type_order == TypeOrder.EIT_ASPORTO || this.cartData.order.type_order == TypeOrder.REST_ASPORTO;
        this.hideCash = this.cartData.order.opzionecoupon == ET_OpzioniCoupon.ONLYCARDS || (isTakeaway && !this.cartData.showcashontakeaway);
        this.hideCash = this.hideCash || (this.cartData.order.credit <= 0.01 && this.cartData.order.creditB && this.cartData.order.creditCorp);
        this.hideCash = this.hideCash || this.cartData.order.euro_tip > 0.01;
      }

    });



    var loc = JSON.parse(localStorage.getItem(DB.LOCATION));

    if (loc) {
      this.location = loc;
    } else {
      //popup
    }

    this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));
  }

  ngOnInit(): void {

    if (this.authService.currentUserValue) {

      // authorised 

    } else {
      //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

      this.route.queryParams.subscribe(params => {
        console.log(params);
        if (params && params.token) {
          let JWToken = params.token;
          console.log("JWTToken: ", JWToken);

          var data: any = {};
          data.externaltoken = JWToken;
          this.api.postj("user/security/logingulliver", data, "").subscribe(res => {
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK) {
              this.authService.next(res[RESPONSE.JP_RESULT]);
            }
          });
        } else {
          //invio a login s sito esterno
          let url = EitUrl.apiLoginGulliver + window.location.href; // + EitEnv.baseUrl +"/checkout"; 
          window.open(url, "_self"/*, "_blank"*/);
        }
      });

    }
  }


  goToPay(payment: any) {

    this.cartService.postPay(this.cartData, payment.id, TypePayment.UNDEF);
    this.eService.deleteToken();
    this.eService.deleteVouchers();

    if (payment.id == TypePayment.MONEY) {
      this.router.navigate(['/cashpay'], { queryParams: { isTicket: 0, token: null, vouchers: null } });
    } else if (payment.id == TypePayment.PAYPAL) {
      this.router.navigate(['/paypalpay'], { queryParams: { isTicket: 0, token: null, vouchers: null } });
    } else if (payment.id == TypePayment.CREDIT) {
      this.router.navigate(['/creditpay'], { queryParams: {} });
    } else if (payment.id == TypePayment.SATISPAY) {
      this.onSatispay();
    }
    else if (payment.id == TypePayment.CARD) {
      this.router.navigate(['/cardpay'], { queryParams: { isTicket: 0, token: null, vouchers: null } });
    } else if (payment.id == TypePayment.INLIRE) {
      this.router.navigate(['/inlirepay'], { queryParams: {} });
    } else if (payment.id == TypePayment.TICKET) {
      this.onEdenred();
    }
  }



  onEdenred() {
    this.eService.deleteToken();
    this.eService.deleteVouchers();
    window.location.href = this.authUrlEdenred;
  }

  editOrderTime() {
    this.cartService.editOrderTime(this.cartData);
  }

  opencouponmodal() {
    console.log("Inserisci coupon");
    var order: any;
    order = this.cartData.order;
    let modal = this.modalService.open(CouponModalComponent, { size: 'md', centered: true, ariaLabelledBy: 'Coupon-Modal', windowClass: 'coupon-modal' })
    modal.componentInstance.order = order
    modal.componentInstance.init()
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if (event.status == RESPONSE.JPS_OK) {
        console.log("dismiss datetime response OK");
        //this.cartData.order.order_date = event.orario;
        //this.cartService.loadCart(this.cartData.order.id);
      } else {
        console.log("dismiss datetime response ERROR");
        //this.cartService.loadCart(this.cartData.order.id);
      }
    })
  }


  onSatispay() {

    var descr = "WWW_Order_" + this.cartData.order_id;
    var callback_url = Satispay.urlCallback + "&idApp=" + AppInfo.APP_ID + "&idOrder=" + this.cartData.order_id;
    // let params = { "ID": this.cartData.order_id, "redirect_url":  Satispay.urlReturn, "description":  descr, "callback_url":  Satispay.urlCallback};
    var tot = (this.cartData.order.euro_total).toFixed(2);
    if (this.cartData.order.ismultiorder) tot = (this.cartData.order.eurocarttotal).toFixed(2);

    var descr = "WWW_Order_" + this.cartData.order_id;
    let params = { "ID": this.cartData.order_id, "redirect_url": Satispay.urlReturn, "description": descr, "callback_url": callback_url, "amount": tot };
    this.api.postj_T("order/satpay", params).subscribe(res => {
      if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK && res[RESPONSE.JP_RESULT]) {
        window.location.href = res[RESPONSE.JP_RESULT]['href'].checkout_url;
      }
    }, (err) => {
      console.log(err);
    });
    /*
    
        this.api.post(urlSat, dataSat,{'headers':headers}).subscribe(res => {
    
          if (res && res.status == 200) {
            var resultData = JSON.parse(res.data);
            window.location.href = resultData.checkout_url;
          }
    
        }, (err) => {
            console.log(err);
    
        });
        */

  }
}
